/**
 * @Author: Nenad Brcic
 * @Date: 23.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import {
    ShareButtons,
    ShareCounts,
} from 'react-share';
import CSSModules from 'react-css-modules';
import styles from '../social-share.scss';

const { FacebookShareButton } = ShareButtons;

const Facebook = ({ title, buttonText, url }) => (
    <div className="content-box">
        <FacebookShareButton url={ url } title={ title }>
            <span>{ buttonText }</span>
        </FacebookShareButton>
    </div>
);

Facebook.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
};

export default CSSModules(Facebook, styles);


// WEBPACK FOOTER //
// ./app/components/shared/SocialShare/service/Facebook.jsx